import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeSmallLinkCtaSkeleton } from "./TypeSmallLinkCta";

/**
 * Fields type definition for content type 'TypePerson'
 * @name TypePersonFields
 * @type {TypePersonFields}
 * @memberof TypePerson
 */
export interface TypePersonFields {
    /**
     * Field type definition for field 'firstName' (First Name)
     * @name First Name
     * @localized false
     */
    firstName: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'lastName' (Last Name)
     * @name Last Name
     * @localized false
     */
    lastName: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'profession' (Profession)
     * @name Profession
     * @localized false
     */
    profession?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'cta' (CTA)
     * @name CTA
     * @localized false
     */
    cta?: EntryFieldTypes.EntryLink<TypeSmallLinkCtaSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'person' (Person)
 * @name TypePersonSkeleton
 * @type {TypePersonSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T00:37:54.153Z
 * @version 9
 */
export type TypePersonSkeleton = EntrySkeletonType<TypePersonFields, "person">;
/**
 * Entry type definition for content type 'person' (Person)
 * @name TypePerson
 * @type {TypePerson}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T00:37:54.153Z
 * @version 9
 */
export type TypePerson<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypePersonSkeleton, Modifiers, Locales>;

export function isTypePerson<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypePerson<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'person'
}
